export const PRODUCTION = import.meta.env.MODE === 'production';
export const DEV = import.meta.env.MODE !== 'production';
export const BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME as string;
export const API_SDK_URL = import.meta.env.VITE_API_SDK_URL as string;
export const COMMON_API_BASE_URL = import.meta.env.VITE_COMMON_API_BASE_URL as string;
// export const COMMON_API_BASE_URL_DEV = import.meta.env.VITE_COMMON_API_BASE_URL_DEV as string;
// export const COMMON_API_BASE_URL_PROD = import.meta.env.VITE_COMMON_API_BASE_URL_PROD as string;
export const MODE = import.meta.env.MODE;
export const BM_MODE = {
  development: 'dev',
  staging: 'stage',
  production: 'prod',
}[MODE];
export const MARPLA_BM_URL = import.meta.env.VITE_MARPLA_BM_URL as string;
export const MARPLA_SALES_URL = import.meta.env.VITE_MARPLA_SALES_URL as string;
export const VITE_PARSE_API_URL = import.meta.env.VITE_PARSE_API_URL as string;
export const VITE_ANALYTICS_PARSE_API_URL = import.meta.env.VITE_ANALYTICS_PARSE_API_URL as string;
export const VITE_BM_API_BASE_URL = import.meta.env.VITE_BM_API_BASE_URL as string;
export const ENV = import.meta.env.VITE_REACT_ENV as string;
export const VITE_WS_GATEWAY_URL = import.meta.env.VITE_WS_GATEWAY_URL as string;
export const VITE_REACT_COMMON_API_BASE_URL = import.meta.env
  .VITE_REACT_COMMON_API_BASE_URL as string;
export const CLOUDPAYMENTS_PUBLIC_TERMINAL_ID = import.meta.env
  .VITE_CLOUDPAYMENTS_PUBLIC_TERMINAL_ID as `${'pk_' | 'test_'}${string}`;
